module.exports = __webpack_public_path__ + "media/images/ticket-dark-9c03546ccd005e0ce148ddecbd7b367c.svg";